import { createFileRoute } from "@tanstack/react-router";
import { comparisonRoute } from "@/lib/seo/comparisonRoute";
import { getComparison } from "@/lib/seo/comparisons";

export const Route = createFileRoute("/jamfor/livsberattelse-pa-film-vs-memoarbok")(
  comparisonRoute(getComparison("livsberattelse-pa-film-vs-memoarbok")),
);
